// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_ak-4";
export var collapsed = "_ak-1";
export var headerBar = "_ak-0";
export var leftHeaderContent = "_ak-3";
export var subjectContainer = "_ak-2";